import React from "react";
import { formatDate } from "../utils/date";
import { Switch } from "./ui/switch";

/**
 * A small inline toggle that renders "Show deleted (N)" with a switch.
 * Caller controls `value` + `onChange` and provides the count.
 */
export default function ShowDeletedToggle({ value, onChange, count, testid = "show-deleted-toggle" }) {
    return (
        <label className="flex items-center gap-2 cursor-pointer text-xs">
            <Switch checked={value} onCheckedChange={onChange} data-testid={testid} />
            <span className="text-[color:var(--asl-muted)]">
                Show deleted{typeof count === "number" ? ` (${count})` : ""}
            </span>
        </label>
    );
}

/**
 * Wraps a row's text contents in strike-through styling when deleted.
 * Adds a small grey pill "Deleted on <date>" to the parent caller as needed.
 */
export function DeletedRowDecorator({ deleted, children }) {
    if (!deleted) return children;
    return (
        <span className="line-through text-[color:var(--asl-muted)] opacity-70">{children}</span>
    );
}

export function DeletedPill({ deletedAt }) {
    if (!deletedAt) return null;
    let when = "—";
    try { when = formatDate(deletedAt); } catch { when = deletedAt; }
    return (
        <span className="ml-2 inline-flex items-center text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-gray-200 text-gray-600" data-testid="deleted-pill">
            Deleted · {when}
        </span>
    );
}
